import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';

const readTheme = () => document.documentElement.getAttribute('data-theme') || 'dark';

const ThemeToggle = () => {
  const [theme, setTheme] = useState(readTheme);
  const isDark = theme === 'dark';

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggle = () => {
    const next = isDark ? 'light' : 'dark';
    setTheme(next);
    try {
      window.localStorage.setItem('theme', next);
    } catch (e) {
      // Storage may be unavailable (private mode); the choice then lasts for this visit only.
    }
  };

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-pressed={isDark}
      aria-label="Dark theme"
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      <FontAwesomeIcon icon={isDark ? faMoon : faSun} aria-hidden="true" />
    </button>
  );
};

export default ThemeToggle;
